/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusWithSections"/>

import * as React from 'react';
import { EmailStatusList } from './components/emailStatusList';

interface EmailStatusWithSectionsProps {
    documentId: number;
    companyId: number;
    importTrackingId?: string | null;
    documentType?: string;
    hashFiles?: { Type: string, Hash: string }[];
    userTaskId?: number;
}

export const EmailStatusWithSections = (props: EmailStatusWithSectionsProps) => {
    return (
        <div>
            <EmailStatusList 
                documentId={props.documentId}
                companyId={props.companyId}
                importTrackingId={props.importTrackingId || undefined}
                documentType={props.documentType}
                hashFiles={props.hashFiles}
                userTaskId={props.userTaskId}
            />
        </div>
    );
};
